window.addEventListener('DOMContentLoaded', () => {

    const formRegister = document.getElementById('create_customer'),
        formLogin = document.getElementById('customer_login');

    let passwordValid = false;

    // validation
    const showError = (field, errorMessage) => {
        let errorTag = field.closest('.field-group').querySelector('.pet-form__field-error');
        field.closest('.field-group').classList.add('is-error');
        if (!errorTag) {
            let errorTag = document.createElement("P");
            errorTag.setAttribute("class", "pet-form__field-error");
            errorTag.innerHTML = errorMessage;
            field.closest('.field-group').appendChild(errorTag);
        } else {
            errorTag.innerHTML = errorMessage;
        }
    }

    const checkPassValid = (input) => {
        if (formLogin && input.value.length < 6) {
            errorMessage = '*Please enter a valid password';
            showError(input, errorMessage)
            return false;
        } else if (formRegister) {
            if (input.value.length < 7 && !/[~`!#$@_%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(input.value) && !/[0-9]|\./g.test(input.value)) {
                errorMessage = '*Minimum 7 characters, 1 number and 1 special character';
                showError(input, errorMessage)
                return false;
            } else if (input.value.length < 7 && !/[~`!#$@_%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(input.value)) {
                errorMessage = '*Minimum 7 characters and 1 special character';
                showError(input, errorMessage)
                return false;
            } else if (input.value.length < 7 && !/[0-9]|\./g.test(input.value)) {
                errorMessage = '*Minimum 7 characters and 1 number';
                showError(input, errorMessage)
                return false;
            } else if (!/[~`!#$@_%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(input.value) && !/[0-9]|\./g.test(input.value)) {
                errorMessage = '*Minimum 1 number and 1 special character';
                showError(input, errorMessage)
                return false;
            } else if (!/[~`!#$@_%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(input.value)) {
                errorMessage = '*Minimum 1 special character';
                showError(input, errorMessage)
                return false;
            } else if (!/[0-9]|\./g.test(input.value)) {
                errorMessage = '*Minimum 1 number';
                showError(input, errorMessage)
                return false;
            } else if (input.value.length < 7) {
                errorMessage = '*Minimum 7 characters';
                showError(input, errorMessage)
                return false;
            }
        }
        
        input.closest('.field-group').classList.remove('is-error');
        let errorTag = input.closest('.field-group').querySelector('.pet-form__field-error');
        if (errorTag) {
            errorTag.remove();
        }
        return true;
    } 

    const checkEmailValid = (input) => {
        const re = /\S+@\S+\.\S+/
        if (!re.test(input.value)) {
            errorMessage = '*Please enter a valid email address such as name@email.com';
            showError(input, errorMessage)
            return false;   
        }
        input.closest('.field-group').classList.remove('is-error');
        let errorTag = input.closest('.field-group').querySelector('.pet-form__field-error');
        if (errorTag) {
            errorTag.remove();
        }
        return true;
    }

    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    function formSend (form) {
        if (form) {

            if (checkPassValid(form.querySelector('[name="customer[password]"]')) === false || checkEmailValid(form.querySelector('[name="customer[email]"]')) === false) {
                return false;
            }

            let formData   = new FormData(),
            formApiData = new FormData(),
            httpRequest  = new XMLHttpRequest(),
            formInputs   = form.querySelectorAll("input"),
            textButtonEl = form.querySelector('.hitail-form__submit-btn'),
            formRedirect = '/account';

            for (let i=0; i < formInputs.length; i++) {
                formData.append(formInputs[i].name, formInputs[i].value);
            }

            formApiData.append('email', form.querySelector('[name="customer[email]"]').value);
            formApiData.append('password', form.querySelector('[name="customer[password]"]').value);

            httpRequest.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    const responseDocument = new DOMParser().parseFromString(this.responseText, 'text/html'),
                    answerForm = responseDocument.getElementById(form.getAttribute('id'));

                    if (!answerForm) {
                        fetch('https://www.hitail.us/api/auth/login', {
                            method: "POST",
                            body: formApiData
                        }) 
                        .then(response => response.json())
                        .then(response => {
                            if (response.status) {
                                setCookie('apiToken', response.token, 3);
                                const urlParams = new URLSearchParams(window.location.search);
                                const currenPetId = urlParams.get('pet_id');
                                const petLocation = urlParams.get('location');
                                const formCookie = getCookie('draftForm');

                                if (currenPetId && petLocation) {
                                    location.href = '/pages/pet-location?pet_id=' + currenPetId;
                                } else if (formCookie) {
                                    document.cookie = 'draftForm=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                                    if (formCookie === 'tag') {
                                        location.href = '/pages/create-pet-tag'
                                    } else {
                                        location.href = '/pages/create-pet'
                                    }
                                } else if (document.querySelector('.hitail-tag-block__input') && document.querySelector('.hitail-tag-block__input').value !== '') {
                                    location.href = `/pages/create-pet-tag?tag=${document.querySelector('.hitail-tag-block__input').value}`;
                                } else {
                                    location.href = formRedirect;
                                }
                            }
                        })
                        .catch(error => {
                            console.error(error);
                            location.href = formRedirect;
                        });
                    } else {
                        let errorsAnswer = answerForm.querySelector('.errors'),
                        errorsDestination = form.querySelector('.errors');

                        if (errorsAnswer && !errorsDestination) {
                            const buttonsBlock = document.querySelector('.hitail-form__buttons');
                            errorsAnswer.classList.add('s-login__error');
                            if (buttonsBlock) {
                                buttonsBlock.insertAdjacentElement('beforebegin', errorsAnswer)
                            } else {
                                form.prepend(errorsAnswer);
                            }
                            return false;
                        } else if (!errorsAnswer && !errorsDestination) {
                            location.href = formRedirect;
                        } else if (!errorsAnswer && errorsDestination)  {
                            errorsDestination.remove();
                            location.href = formRedirect;
                        }
                    } 
                }
            };

            httpRequest.onloadstart = function () {
                textButtonEl.classList.add('is-loading');
            }

            httpRequest.onload = function () {
                textButtonEl.classList.remove('is-loading');
            }

            httpRequest.open('post', form.getAttribute('action'));
            httpRequest.send(formData);
        }
    }

    const submitBtn = document.querySelector('.hitail-form__submit-btn');
    if (submitBtn) {
        submitBtn.addEventListener('click', () => {
            if (formLogin) {
                formSend(formLogin);
            } else if (formRegister) {
                formSend(formRegister);
            }
        })
    }

    // SHOW/HIDE PASSWORD
    const passwordBtn = document.querySelectorAll('.password-btn');
    if (passwordBtn.length) {
        passwordBtn.forEach((el) => {
            el.addEventListener('click', () => {
                const passwordInput = el.closest('.password-wrapper').querySelector('.hitail-form__input-password');
                passwordInput.getAttribute('type') === 'password' ? passwordInput.setAttribute('type', 'text') : passwordInput.setAttribute('type', 'password');
            })
        })
    }

    // SAVE LOCALSTORAGE (and pass validation)
    const inputs = document.querySelectorAll('[name="customer[email]"], [name="customer[password]"]');
    inputs.forEach((input) => {
        input.addEventListener('input', () => {
            window.localStorage.setItem('customer', JSON.stringify({
                email: inputs[0].value, 
                password: inputs[1].value
            }));

            // password validation
            if (formRegister && input.name === 'customer[password]') {
                checkPassValid(input)
            }
        })
    })

    const emailInputs = document.querySelectorAll('[name="customer[password]"], [name="customer[email]"], [name="email"]');
    emailInputs.forEach((input) => {
        input.addEventListener('change', () => {
            // email validation
            if (input.name === 'customer[email]' || input.name === 'email') {
                checkEmailValid(input)
            }

            if (formLogin && input.name === 'customer[password]') {
                checkPassValid(input)
            }
        });
    });
});
  
// GET LOCASTORAGE
(function () {
	window.onpageshow = function(event) {
		if (event.persisted) {
			window.location.reload();
		}
	};
})();
const customer = JSON.parse(window.localStorage.getItem('customer'));
if (customer) {
    document.querySelector('[name="customer[email]"]').value = customer.email;
    document.querySelector('[name="customer[password]"]').value = customer.password;
}